(function () {
  'use strict';
  function initialize() {
    var api = window.RMBlackFriday2026;
    if (!api) return;
    document.querySelectorAll('[data-rm-bf-2026]').forEach(function (root) {
      if (root.dataset.bfReady === 'true') return;
      var form = root.querySelector('[data-bf-form]');
      if (!form) return;
      var config = api.readRootConfig(root);
      var french = config.uiLanguage === 'fr';
      var email = form.querySelector('[name=email]');
      var phone = form.querySelector('[name=phone]');
      var honeypot = form.querySelector('[name=website]');
      var emailError = form.querySelector('[data-bf-email-error]');
      var phoneError = form.querySelector('[data-bf-phone-error]');
      var submit = form.querySelector('[data-bf-submit]');
      var back = form.querySelector('[data-bf-back]');
      var progress = form.querySelector('[data-bf-progress]');
      var nextHint = form.querySelector('[data-bf-next-hint]');
      var status = root.querySelector('[data-bf-status]');
      var success = root.querySelector('[data-bf-success]');
      var gate = api.createSubmissionGate();
      var step = 1;
      function showStep(next, focus) {
        step = next;
        form.dataset.step = String(step);
        form.querySelector('[data-bf-step="1"]').hidden = step !== 1;
        form.querySelector('[data-bf-step="2"]').hidden = step !== 2;
        phone.disabled = step !== 2;
        back.hidden = step !== 2;
        nextHint.hidden = step !== 1;
        progress.textContent = step === 1
          ? (french ? 'ÉTAPE 1 SUR 2 · EMAIL' : 'STEP 1 OF 2 · EMAIL')
          : (french ? 'ÉTAPE 2 SUR 2 · TÉLÉPHONE' : 'STEP 2 OF 2 · PHONE');
        submit.innerHTML = '<span>' + (step === 1
          ? (french ? 'CONTINUER' : 'CONTINUE')
          : (french ? 'M’INSCRIRE' : 'SIGN ME UP')) + '</span><span aria-hidden="true">↗</span>';
        status.textContent = '';
        if (focus) (step === 1 ? email : phone).focus();
      }
      showStep(1, false);
      back.addEventListener('click', function () {
        if (!gate.isPending()) showStep(1, true);
      });
      root.dataset.bfReady = 'true';
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (gate.isPending() || form.hidden) return;
        var input = api.validateSignupInput({ email: email.value, phone: phone.value, honeypot: honeypot.value });
        emailError.textContent = input.errors.email ? (french ? 'Indique une adresse email valide.' : 'Enter a valid email address.') : '';
        email.setAttribute('aria-invalid', input.errors.email ? 'true' : 'false');
        status.textContent = '';
        if (input.errors.email) {
          showStep(1, true);
          return;
        }
        if (input.errors.honeypot) return;
        if (step === 1) {
          showStep(2, true);
          return;
        }
        phoneError.textContent = input.errors.phone === 'required'
          ? (french ? 'Indique ton numéro de téléphone pour continuer.' : 'Enter your phone number to continue.')
          : input.errors.phone ? (french ? 'Utilise le format international, par exemple +33 6 12 34 56 78.' : 'Use international format, for example +1 202 555 0123.') : '';
        phone.setAttribute('aria-invalid', input.errors.phone ? 'true' : 'false');
        if (input.errors.phone) {
          phone.focus();
          return;
        }
        await gate.run(async function () {
          submit.disabled = true;
          back.disabled = true;
          email.disabled = true;
          phone.disabled = true;
          form.setAttribute('aria-busy', 'true');
          submit.textContent = french ? 'UN INSTANT…' : 'ONE MOMENT…';
          var payload = api.buildSubscriptionParams({ listId: config.listId, email: input.email, phone: input.phone, context: config.context, utm: api.readUtmParams(window.location.search) });
          var result = await api.submitSubscription({ endpoint: config.endpoint, payload: payload, timeoutMs: 15000 });
          if (result.ok) {
            form.hidden = true;
            success.hidden = false;
            status.textContent = '';
            success.focus();
          } else {
            showStep(2, false);
            status.textContent = api.getStatusMessage(config.uiLanguage, result.kind);
            submit.disabled = false;
            back.disabled = false;
            email.disabled = false;
            phone.disabled = false;
          }
          form.removeAttribute('aria-busy');
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
